interface OnlinePaymentConsentProps {
  organizationName?: string;
}

export function OnlinePaymentConsent({ organizationName }: OnlinePaymentConsentProps) {
  return (
    <div className="sui-text-caption sui-text-gray" data-testid="online-payment-consent">
      By submitting my payment, I authorize TeamSnap and {organizationName ?? 'Organization'} to store my payment method
      for merchant-initiated transactions including refunds, future purchases I initiate, and
      authorized recurring or future-dated charges. I understand I'll receive notification of
      any charges, and I may contact {organizationName ?? 'Organization'} directly for any payment disputes relating to
      this transaction.
    </div>
  );
}